// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.container-img{
  background-color:#FFFFFF;
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
}

#img-mapa {
  -webkit-transition: all .2s ease-in-out;
  -moz-transition: all .2s ease-in-out;
  -o-transition: all .2s ease-in-out;
  -ms-transition: all .2s ease-in-out;
  /*position: absolute;*/
  top: 0;
  left: 0;
  transform: scale(1);
  transform-origin: 0 0;
}

.plano{
  max-width: 960px;
}

.masthead{
  background-color: #000000 !important;
}
.links{
  position: absolute;
  cursor: pointer;
  font-size: 10px;
  text-align: center;
  color: #FFFFFF;
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-color: rgba(255, 0, 0, 0.3);
  left: 240px;
  top: 126px;
}
.links.focused:after{
  position: absolute;
  top: -5px;
  height: calc(100% + 10px);
  left: -5px;
  width: calc(100% + 10px);
  /*border: 2px solid rgba(120, 0, 0, 0.7);*/
  content: '';
  display: block;
  border-radius: 50%;
}
.act{
  background-color: rgba(255, 0, 0, 0.7);
}
#link-1{
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-color: rgba(255, 0, 0, 0.7);
  left: 240px;
  top: 126px;
}
#link-2{
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-color: rgba(127, 191, 63, 0.7);
  left: 388px;
  top: 126px;
}
.nav-zoom{
  background: #f0f0f0;
  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);
  color: #000000;
}
.logo-most{
  max-width: 270px;
}
.logo-ypf{
  max-width: 150px;
}
.cover-container{
  position: relative;
  padding-left: 0rem!important;
  padding-right: 0rem!important;
  padding-bottom: 0rem!important;
  padding-top: 0!important;
}

.modal-content{
  color: #0b2e13;
}
.collapse{
  border-bottom: #4c5978 2px solid;
}


.modal table{
  font-size: 12px !important;
}
.f-10{
  font-size: 10px !important;
}
.f-11{
  font-size: 11px !important;
}
.f-12{
  font-size: 12px !important;
}
.f-13{
  font-size: 13px !important;
}
.f-14{
  font-size: 14px !important;
}

.modal-lg {
  max-width: 1024px !important;
}

#color-link1{
  color: transparent !important;
}

.id-destacado{
    font-size: 2em;
    color: red;
    font-weight: bold;
}
.estadisticaBtn {text-align: center;}
.estadisticaBtn img{margin: 20px;}
.estadisticaBtn.active{font-weight: bold;}
.number{text-align: right;}


.modal .select2-results__option[aria-selected] {
    color: black !important;
}
`, "",{"version":3,"sources":["webpack://./src/resources/css/custom.css"],"names":[],"mappings":";AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,kCAAkC;EAClC,mCAAmC;EACnC,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,UAAU;EACV,wBAAwB;EACxB,0CAA0C;EAC1C,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;EAMnB,uFAAuF;EACvF,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;;;AAGA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;IACI,cAAc;IACd,UAAU;IACV,iBAAiB;AACrB;AACA,iBAAiB,kBAAkB,CAAC;AACpC,oBAAoB,YAAY,CAAC;AACjC,uBAAuB,iBAAiB,CAAC;AACzC,QAAQ,iBAAiB,CAAC;;;AAG1B;IACI,uBAAuB;AAC3B","sourcesContent":["\r\n.container-img{\r\n  background-color:#FFFFFF;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n  position: relative;\r\n}\r\n\r\n#img-mapa {\r\n  -webkit-transition: all .2s ease-in-out;\r\n  -moz-transition: all .2s ease-in-out;\r\n  -o-transition: all .2s ease-in-out;\r\n  -ms-transition: all .2s ease-in-out;\r\n  /*position: absolute;*/\r\n  top: 0;\r\n  left: 0;\r\n  transform: scale(1);\r\n  transform-origin: 0 0;\r\n}\r\n\r\n.plano{\r\n  max-width: 960px;\r\n}\r\n\r\n.masthead{\r\n  background-color: #000000 !important;\r\n}\r\n.links{\r\n  position: absolute;\r\n  cursor: pointer;\r\n  font-size: 10px;\r\n  text-align: center;\r\n  color: #FFFFFF;\r\n  width: 75px;\r\n  height: 75px;\r\n  border-radius: 50%;\r\n  background-color: rgba(255, 0, 0, 0.3);\r\n  left: 240px;\r\n  top: 126px;\r\n}\r\n.links.focused:after{\r\n  position: absolute;\r\n  top: -5px;\r\n  height: calc(100% + 10px);\r\n  left: -5px;\r\n  width: calc(100% + 10px);\r\n  /*border: 2px solid rgba(120, 0, 0, 0.7);*/\r\n  content: '';\r\n  display: block;\r\n  border-radius: 50%;\r\n}\r\n.act{\r\n  background-color: rgba(255, 0, 0, 0.7);\r\n}\r\n#link-1{\r\n  width: 75px;\r\n  height: 75px;\r\n  border-radius: 50%;\r\n  background-color: rgba(255, 0, 0, 0.7);\r\n  left: 240px;\r\n  top: 126px;\r\n}\r\n#link-2{\r\n  width: 75px;\r\n  height: 75px;\r\n  border-radius: 50%;\r\n  background-color: rgba(127, 191, 63, 0.7);\r\n  left: 388px;\r\n  top: 126px;\r\n}\r\n.nav-zoom{\r\n  background: #f0f0f0;\r\n  background: -moz-linear-gradient(top, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);\r\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(255,255,255,1)), color-stop(100%,rgba(240,240,240,1)));\r\n  background: -webkit-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  background: -o-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  background: -ms-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(240,240,240,1) 100%);\r\n  color: #000000;\r\n}\r\n.logo-most{\r\n  max-width: 270px;\r\n}\r\n.logo-ypf{\r\n  max-width: 150px;\r\n}\r\n.cover-container{\r\n  position: relative;\r\n  padding-left: 0rem!important;\r\n  padding-right: 0rem!important;\r\n  padding-bottom: 0rem!important;\r\n  padding-top: 0!important;\r\n}\r\n\r\n.modal-content{\r\n  color: #0b2e13;\r\n}\r\n.collapse{\r\n  border-bottom: #4c5978 2px solid;\r\n}\r\n\r\n\r\n.modal table{\r\n  font-size: 12px !important;\r\n}\r\n.f-10{\r\n  font-size: 10px !important;\r\n}\r\n.f-11{\r\n  font-size: 11px !important;\r\n}\r\n.f-12{\r\n  font-size: 12px !important;\r\n}\r\n.f-13{\r\n  font-size: 13px !important;\r\n}\r\n.f-14{\r\n  font-size: 14px !important;\r\n}\r\n\r\n.modal-lg {\r\n  max-width: 1024px !important;\r\n}\r\n\r\n#color-link1{\r\n  color: transparent !important;\r\n}\r\n\r\n.id-destacado{\r\n    font-size: 2em;\r\n    color: red;\r\n    font-weight: bold;\r\n}\r\n.estadisticaBtn {text-align: center;}\r\n.estadisticaBtn img{margin: 20px;}\r\n.estadisticaBtn.active{font-weight: bold;}\r\n.number{text-align: right;}\r\n\r\n\r\n.modal .select2-results__option[aria-selected] {\r\n    color: black !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
